<template>
    <pull-to :top-load-method="onLoad" :topConfig="topConfig">
        <slot />
    </pull-to>
</template>

<script>
import PullTo from 'vue-pull-to'

const TOP_DEFAULT_CONFIG = {
    pullText: 'Ziehen zum Laden', // The text is displayed when you pull down
    triggerText: 'Ziehen zum Laden', // The text that appears when the trigger distance is pulled down
    loadingText: 'Lädt...', // The text in the load
    doneText: 'Fertig', // Load the finished text
    failText: 'Fehler beim Laden', // Load failed text
    loadedStayTime: 400, // Time to stay after loading ms
    stayDistance: 50, // Trigger the distance after the refresh
    triggerDistance: 70, // Pull down the trigger to trigger the distance
}

export default {
    name: 'PullToRefresh',

    components: { PullTo },

    data: () => ({
        topConfig: TOP_DEFAULT_CONFIG,
    }),

    methods: {
        onLoad (loaded) {
            this.$emit('load', loaded)
        },
    },
}
</script>
